module.exports = __webpack_public_path__ + "static/media/BlueSearch.884d47cd.svg";